<template>
  <el-dialog
    title="从项目中导入专家"
    :visible.sync="visible"
    width="900px"
    class="dialog"
    :close-on-click-modal="false"
  >
    <el-form :model="filterForm" inline label-suffix="：">
      <el-form-item label="项目编号或名称" prop="projectCodeOrName">
        <el-input
          v-model.trim="filterForm.projectCodeOrName"
          placeholder="请填写项目编号或名称"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <jczh-table-content
      :data="list"
      :option="listOption"
      pagination
      :page.sync="page"
      :limit.sync="size"
      :total="total"
    >
      <template v-slot:last>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="importExpert(row)">导入</el-button>
          </template>
        </el-table-column>
      </template>
    </jczh-table-content>
  </el-dialog>
</template>

<script>
import { projectTypeDict } from '@/dictionary/project/common'
import listFilterMixin from '@/mixins/list-filter-mixin'
import useReviewOrder from '@/components/online-review/hooks/useReviewOrder'

/**
 * 历史线上评审项目
 */
export default {
  name: 'OnlineReviewHistoryDialog',

  inject: ['provideReviewId', 'providePurchaseType', 'provideCopyReviewer'],

  mixins: [listFilterMixin],

  data() {
    return {
      visible: false,

      filterForm: {
        projectCodeOrName: ''
      },
      list: [],
      total: 0,
      listOption: [
        { label: '项目名称', prop: 'orderName' },
        { label: '项目编号', prop: 'orderCode' },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || '-'
        },
        // { label: '发布人', prop: 'purchaseEmployeeName' },
        { label: '专家数', prop: 'reviewExpertCnt' }
      ]
    }
  },

  computed: {
    reviewId() {
      return this.provideReviewId()
    },

    purchaseType() {
      return this.providePurchaseType()
    }
  },

  methods: {
    openDialog() {
      this.visible = true
      this.handleSearch()
    },

    closeDialog() {
      this.visible = false
    },

    getList() {
      console.log('getList')
      useReviewOrder()
        .getOrderPage({
          purchaseType: this.purchaseType,
          params: Object.assign({}, this.filterForm, {
            page: this.page,
            size: this.size
          })
        })
        .then(data => {
          this.list = data?.records || []
          this.total = data?.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    importExpert(row) {
      this.provideCopyReviewer(
        Object.assign({}, row, { reviewId: row.onlineReviewId })
      ).then(() => {
        this.closeDialog()
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
